import FormattedMessage from 'I18n/components/FormattedMessage';
import StaticBranchName from 'automation-ui-action-features/actions/static-branch/StaticBranchName';
import { getBranchIndex, getPreviousActionId, isDefaultBranchIndex } from 'automation-ui-action-features/records/recordsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const BranchName = ({
  flow,
  edgeId,
  handleGetActionOutputsForTargetActionById
}) => {
  if (!flow) {
    return null;
  }
  const actionId = getPreviousActionId(edgeId);
  const branchIndex = getBranchIndex(edgeId);
  const action = flow.getActionById(actionId);
  if (!action) {
    return null;
  }
  const connection = action.getConnection();
  let content = /*#__PURE__*/_jsx("div", {});
  if (isDefaultBranchIndex(branchIndex)) {
    content = connection.getDefaultBranchName() ? /*#__PURE__*/_jsx("span", {
      children: connection.getDefaultBranchName()
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "action-features.list-branch.branch-label.otherwiseDefaultBranchName"
    });
  } else {
    const branches = connection.getBranches();
    const branch = branches ? branches.get(branchIndex) : null;
    if (branch) {
      if (action.isABTestBranch()) {
        content = branch.getBranchName() ? /*#__PURE__*/_jsx("span", {
          children: branch.getBranchName()
        }) : /*#__PURE__*/_jsx("span", {
          children: connection.getPlaceholderBranchName()
        });
      } else if (action.isStaticBranch()) {
        content = /*#__PURE__*/_jsx(StaticBranchName, {
          action: action,
          branch: branch,
          branchIndex: branchIndex,
          propertyTypeId: flow.getObjectTypeId(),
          getActionOutputsForTargetActionById: handleGetActionOutputsForTargetActionById
        });
      } else {
        content = branch.getBranchName() ? /*#__PURE__*/_jsx("span", {
          children: branch.getBranchName()
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "action-features.list-branch.branch-label.default",
          options: {
            branchNumber: branchIndex + 1
          }
        });
      }
    }
  }
  return content;
};
export default BranchName;